import { Stack } from "@mui/material";

import PaginationControlsV2 from "../../../../../global/PaginationControlsV2";
import HNSColors from "../../../../../ui library/HNSColors";
import { useProvidedServicesStore } from "../../store/services-provided/providedServicesStore";
import { useServicesStore } from "../../store/services-provided/servicesStore";
import STRINGS from "../../utils/strings";
import LoadingIndicator from "../fields/LoadingIndicator";
import SearchBar from "../fields/SearchBar";

import ServicesHeader from "./ServicesHeader";
import ServicesList from "./ServicesList";

export default function AvailableServices() {
  const {
    data,
    loading,
    currentSearch,
    setCurrentSearch,
    resultCount,
    currentPage,
    resLimit,
    setCurrentPage,
    resetCurrentPage,
  } = useProvidedServicesStore();
  const { selectedProvidedServices, servicesToBeAdded, servicesToBeRemoved } = useServicesStore();
  const handlePageChange = (_, newPage) => setCurrentPage(newPage);
  const getId = (s) => s.id ?? s.service?.id;

  const removedIds = new Set((servicesToBeRemoved ?? []).map(getId));

  const combinedData = Array.from(
    new Map(
      [...(servicesToBeAdded ?? []), ...(data ?? [])]
        .filter((s) => !removedIds.has(getId(s)))
        .map((s) => [getId(s), s])
    ).values()
  );

  return (
    <div
      className="min-w-1/2 flex h-full min-h-0 w-1/2 flex-col gap-2 rounded-[14px] p-4"
      style={{ backgroundColor: HNSColors.neutrals[900] }}
    >
      {loading ? (
        <LoadingIndicator />
      ) : (
        <>
          <ServicesHeader
            title={STRINGS.HEADERS.PROVIDED_SERVICES}
            selectedServices={selectedProvidedServices.length}
            totalServices={resultCount}
          />
          <SearchBar
            searchText={currentSearch}
            setSearchText={setCurrentSearch}
            resetCurrentPage={resetCurrentPage}
          />
          <ServicesList data={combinedData} serviceType={STRINGS.SERVICE_TYPE.PROVIDED} />
          {resultCount > STRINGS.DEFAULT_PROVIDED_SERVICES_PAGINATION_LIMIT && (
            <div className={`flex w-full justify-center`}>
              <Stack alignItems="center">
                <PaginationControlsV2
                  alignment="center"
                  resultCount={resultCount}
                  handleChange={handlePageChange}
                  currentPage={currentPage}
                  resultLimit={resLimit}
                />
              </Stack>
            </div>
          )}
        </>
      )}
    </div>
  );
}
